module.exports = __webpack_public_path__ + "static/media/mi.6a86f8df.png";